<template>
  <div class="c-note-list">
    <div class="c-note-list__content">

      <ul class="note-list">
        <li class="note-list__item" v-for="d of noteList.accountNoteContents" :key="d.accountNoteUid">
          <div class="item-row">
            <div class="item-row__basic">
              <p class="item-row__basic__title">{{ d.content }}</p>
              <p class="item-row__basic__time">{{ dayjs(d.updatedAt).format('D MMM YYYY HH:mm') }}</p>
            </div>
            <div class="item-row__action">
              <div class="item-row__action__edit" @click="openEditNoteModal(d)">
                <span class="item-row__action__edit__text">{{ $t('global.edit') }}</span>
              </div>
              <img class="item-row__action__delete" src="@/assets/searchResults/icon_popup_note_delete.svg"
                @click="deleteNote(d.accountNoteContentUid)" />
            </div>
          </div>
        </li>
      </ul>
    </div>

    <n-modal v-model:show="modelStatus" preset="dialog" :show-icon="false" :style="{ 'max-width': '800px' }">
      <model-base-layout :title="`${$t('myMusic.editNote')} - ${data.title}(${editType}/${versionType})`">
        <edit-note :data="data" :noteData="noteData" @close="handleModelStatus" />
      </model-base-layout>
    </n-modal>
  </div>
</template>
<script>
import {
  defineComponent, watch, ref, provide, inject, computed,
} from 'vue';
import dayjs from 'dayjs';
import { NModal, useMessage } from 'naive-ui';
import { useI18n } from 'vue-i18n';
import { removeAccountNoteAPI, getAccountNoteAPI } from '@/api/myMusicNotes';
import useRequest from '@/hooks/useRequest';
import ModelBaseLayout from '@/components/Global/Popup/ModelBaseLayout.vue';
import EditNote from '@/components/Global/Popup/EditNote.vue';
import { useCacheStore } from '@/store/cache';

export default defineComponent({
  name: 'NoteList',
  components: {
    NModal,
    ModelBaseLayout,
    EditNote,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { t } = useI18n();
    const { request, response } = useRequest(getAccountNoteAPI);
    const { request: removeAccountNoteRequest, response: removeAccountNoteResponse } = useRequest(removeAccountNoteAPI);
    const message = useMessage();
    const noteList = ref([]);
    const noteData = ref('');
    const modelStatus = ref(false);
    const cacheStore = useCacheStore();

    const editType = computed(() => {
      return props.data?.editType || props.data?.track?.editType || '';
    });

    const versionType = computed(() => {
      return props.data?.versionType || props.data?.track?.versionType || '';
    });

    const handleNoteContentRequest = () => {
      request({
        in: {
          // keyword: keyword.value,
          keyword: '',
          accountNoteUid: props.data.accountNoteUid,
        },
      });
    };

    handleNoteContentRequest();
    provide('reloadNoteContentRequest', handleNoteContentRequest);

    watch(response, () => {
      const [err, res] = response.value;

      if (err) {
        // message.error(err.message);
        return;
      }

      if (res) {
        // const { accountNoteContents } = res.getAccountNote;

        res.getAccountNote.accountNoteContents = res.getAccountNote.accountNoteContents.map((item) => {
          item.time = dayjs(item.updatedAt).format('D MMM YYYY HH:mm');

          return item;
        });

        noteList.value = res.getAccountNote;
      }
    });

    const handleModelStatus = (status = true) => {
      modelStatus.value = status;
    };

    const openEditNoteModal = (content) => {
      noteData.value = content;
      handleModelStatus();
    };

    const deleteNote = (id) => {
      removeAccountNoteRequest({
        in: id,
      });
    };

    const reloadGetAccountNoteList = inject('reloadGetAccountNoteList');

    watch(removeAccountNoteResponse, () => {
      const [err, res] = removeAccountNoteResponse.value;

      if (err) {
        message.error(err.toString());
        return;
      }

      if (res) {
        message.success(t('msg.removeNoteSuccess'));
        // 更新有 Note 的 track
        cacheStore.trackWithNotesReq();

        // 剩餘一個如果刪除成功，這首曲目也會一併刪除，如果再 call api 會找不捯此曲目的筆記而報錯
        if (noteList.value.accountNoteContents.length !== 1) {
          handleNoteContentRequest();
        } else {
          reloadGetAccountNoteList();
        }
      }
    });

    return {
      noteList,
      openEditNoteModal,
      modelStatus,
      noteData,
      deleteNote,
      handleModelStatus,
      dayjs,
      handleNoteContentRequest,
      editType,
      versionType,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-note-list {
  background-color: $c-white3;

  &__content {
    height: 200px;
    overflow: auto;
  }
}

.note-list {
  &__item {
    @include padding(23px 20px);
    border-bottom: 1px solid $c-assist7;
  }
}

.item-row {
  @include flex(space-between, flex-start);

  &__basic {
    &__title {
      @include font-style($c-black, 14, normal, 0.8px, 26px);
    }

    &__time {
      @include font-style($c-assist4, 12, normal, 0.6px, 18px);
    }
  }

  &__action {
    @include flex(flex-end);
    flex: none;
    width: 100px;

    &__edit {
      @include padding(0 10px);
      @include flex(center);
      display: inline-block;
      background-color: $c-assist15;
      height: 26px;
      border-radius: 13px;
      cursor: pointer;

      &__text {
        @include font-style($c-white, 14, normal, 0.7px, 26px);
      }
    }

    &__delete {
      margin-left: 20px;
      cursor: pointer;
    }
  }
}

@media screen and (min-width: $sm-pc) {
  .c-note-list {
    // @include padding(0 80px 0 0);
  }

  .note-list {
    &__item {
      @include padding(23px 0 23px 20px);
    }
  }

  .item-row {
    @include padding(0 80px 0 0);
  }
}
</style>
